// Retries dynamic import if chunk loading fails (e.g. after a deployment)
export const retryRemoteComponent = (fn, retriesLeft = 2, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }
          retryRemoteComponent(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};